@if (typeSelectItems && typeSelectItems.length) {
  @if (header) {
    <app-header
      styleClass="mt-5"
      [text]="header.text"
      [icon]="header.icon"></app-header>
  }
  <p-multiSelect
    *ngIf="typeSelectItems as types"
    [options]="types"
    [disabled]="disabled"
    [(ngModel)]="selection"
    (ngModelChange)="onChange(selection)"
    display="chip"
    placeholder="auswählen..."
    optionLabel="name">
    <ng-template let-item pTemplate="selectedItem">
      <div class="flex align-items-center gap-2">
        <app-data-layer-type-name [dataLayerType]="item" />
      </div>
    </ng-template>
    <ng-template let-item pTemplate="item">
      <div class="flex align-items-center gap-2">
        <app-data-layer-type-name [dataLayerType]="item" />
      </div>
    </ng-template>
  </p-multiSelect>
}
